import styled from 'styled-components';
import { PasswordInput } from '@carvana/showroom-forms';

export const FormWrapper = styled.form`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

export const FormInput = styled(PasswordInput)`
  width: 480px;
`;
